import React, {useState} from "react";
import useFetch from '@common/hooks/fetch/useFetch'
import {getAdCategoryList} from '@common/services/restapi/ad/index'
import {Moments} from '@common/utils/date/moments'

function SamplePage() {
  const [adCategorySearch, setAdCategorySearch] = useState({
    category: 'tv',
    sortField1: 'wdate',
    sortOption1: 'DESC',
    pageNumber: 1,
    pageSize: 5
  });
  const {data: adCategoryList} = useFetch(() => getAdCategoryList(adCategorySearch), [adCategorySearch], {});

  return (
    <div>
      <h2>SAMPLE</h2>
      {adCategoryList && adCategoryList.adList && adCategoryList.adList.map((ad, index) => {
        return (
          <div key={`ad-${index}`}>
            <div>{ad.title} </div>
            <div>{Moments.Format(ad.wdate, 'yyyy-MM-DD')} </div>
          </div>
        )
      })}
    </div>
  );
}

export default SamplePage;
